import { HttpClient } from 'api/http-client';
import { EmailMessage } from './types';

export type { EmailMessage };
export type { EmailMessageAttachment } from './types';

class EmailMessagesClient extends HttpClient {
  public getMessages(sourceId: number): Promise<EmailMessage[]> {
    return this.get<EmailMessage[]>(`/scarlet/emails/${sourceId}/messages`);
  }

  public getSummary(sourceId: number): Promise<string[]> {
    return this.get<string[]>(`/scarlet/emails/${sourceId}/summary`);
  }
}

export const EmailMessagesAPI = new EmailMessagesClient();
